module.exports = __webpack_public_path__ + "static/media/add-absence.877c1443.svg";